// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/cross.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notificationMain {
  background-color: #07405E;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  overflow-y: auto;
}
.notificationMain .notificationContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .notificationMain .notificationContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .notificationMain .notificationContainer {
    height: 100%;
  }
}
.notificationMain .notificationContainer .markAll {
  height: 38px;
  border-radius: 8px;
  border: 0.8px solid #699BB6;
  background: rgba(255, 255, 255, 0);
  padding: 0px 22px;
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  margin: 30px 0px 30px 0px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 155%;
  width: 200px;
  cursor: pointer;
}
.notificationMain .notificationContainer .notificationBlock {
  width: 97%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.notificationMain .notificationContainer .notificationBlock .notificationDate {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.notificationMain .notificationContainer .notificationBlock .notificationDescBlock {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 97%;
}
.notificationMain .notificationContainer .notificationBlock .notificationDescBlock .notificationDesc {
  color: #FFFFFF;
  leading-trim: both;
  text-edge: cap;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  width: 90%;
  /* 18px */
}
.notificationMain .notificationContainer .notificationBlock .notificationDescBlock .unreadNotifications {
  height: 18px;
  width: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  cursor: pointer;
}

a {
  color: #FFFFFF;
  leading-trim: both;
  text-edge: cap;
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  width: 90%;
}

.customNotifcationContainer {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .customNotifcationContainer {
    width: 400px;
    border-radius: 20px;
  }
}
.customNotifcationContainer .ellipse {
  border-radius: 25%;
}
.customNotifcationContainer .headerText {
  text-align: center;
  font-family: "Crimson Pro", serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: 110%;
  width: 100%;
  padding: 0;
  margin: 10px 0px 10px 0px;
  margin-bottom: 20px;
}
.customNotifcationContainer .description {
  color: #699BB6;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  margin-bottom: 30px;
}
@media (max-width: 720px) {
  .customNotifcationContainer .description {
    font-size: 14px;
  }
}
.customNotifcationContainer .successBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  font-weight: 400;
  margin-top: 50px;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  border: 0px solid;
  position: absolute;
  bottom: 100px;
}
.customNotifcationContainer .skipBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  background: -webkit-linear-gradient(#6D4ECB, #FF6B6B);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-color: #fff;
  font-weight: 400;
  margin-top: 20px;
  padding: 8px 10px 8px 10px;
  border-radius: 10px;
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  border: 0px solid;
  position: absolute;
  bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./src/modules/notifications/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAEI;EAII,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AANR;AANQ;EADJ;IAEQ,YAAA;EASV;AACF;AAPQ;EALJ;IAMQ,YAAA;EAUV;AACF;AAHQ;EACI,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,kCAAA;EACA,iBAAA;EACA,cC9BK;ED+BL,iCE3BH;EF4BG,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAKZ;AAHQ;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AAKZ;AAHY;EACI,cChDC;EDiDD,iCE7CP;EF8CO,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAKhB;AAHY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AAKhB;AAJgB;EACI,cC9DP;ED+DO,kBAAA;EACA,cAAA;EACA,iCE5DX;EF6DW,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;AAMpB;AAJgB;EACI,YAAA;EACA,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,eAAA;AAMpB;;AAEA;EACI,cCvFS;EDwFT,kBAAA;EACA,cAAA;EACA,iCErFK;EFsFL,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AACJ;;AACA;EAKQ,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AAFR;AATQ;EADR;IAEY,YAAA;IACA,mBAAA;EAYV;AACF;AAHQ;EACI,kBAAA;AAKZ;AAHQ;EACI,kBAAA;EACA,iCEjHE;EFkHF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;AAKZ;AAHQ;EACI,cC7HK;ED8HL,kBAAA;EACA,iCE3HH;EF4HG,eAAA;EAIA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAEZ;AATY;EALJ;IAMQ,eAAA;EAYd;AACF;AAJQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uDAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cCvJC;EDwJD,iCEnJH;EFoJG,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AAMZ;AAJQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,cC5KC;ED6KD,iCExKH;EFyKG,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAMZ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.notificationMain {\n    background-color: #07405E;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    overflow-y: auto;\n    .notificationContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        height: 85%;\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        width: 100%;\n        height: 100dvh;\n        padding: 10px;\n        .markAll{\n            height: 38px;\n            border-radius: 8px;\n            border: 0.8px solid $color-Secondary;\n            background: rgba(255, 255, 255, 0);\n            padding: 0px 22px;\n            color: $color-Secondary;\n            font-family: $Roboto;\n            margin: 30px 0px 30px 0px;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 155%;\n            width: 200px;\n            cursor: pointer;\n        }\n        .notificationBlock{ \n            width: 97%;\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-start;\n            align-items: flex-start;\n\n            .notificationDate{\n                color: $color-Secondary;\n                font-family: $Roboto;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: normal;\n            }\n            .notificationDescBlock{\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                width: 97%;\n                .notificationDesc{\n                    color: $color-White;\n                    leading-trim: both;\n                    text-edge: cap;\n                    font-family: $Roboto;\n                    font-size: 15px;\n                    font-style: normal;\n                    font-weight: 400;\n                    line-height: 120%;\n                    width: 90%;\n                    /* 18px */\n                }\n                .unreadNotifications{\n                    height: 18px;\n                    width: 18px;\n                    background-image: url('../../assets/icons/cross.png');\n                    background-size: cover;\n                    cursor: pointer;\n                    \n                }\n\n            }\n        }\n    }\n}\na {\n    color: $color-White;\n    leading-trim: both;\n    text-edge: cap;\n    font-family: $Roboto;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%;\n    width: 90%;\n}\n.customNotifcationContainer{\n        @media (min-width: 450px){\n            width: 400px;\n            border-radius: 20px;\n        }\n        background-color: white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        width: 100%;\n        height: 100dvh;\n        padding: 10px;\n        .ellipse{\n            border-radius: 25%;\n        }\n        .headerText {\n            text-align: center;\n            font-family: $Crimson-Pro;\n            font-size: 40px;\n            font-style: normal;\n            font-weight: 900;\n            line-height: 110%;\n            width: 100%;\n            padding:0;\n            margin: 10px 0px 10px 0px;\n            margin-bottom: 20px;\n        }\n        .description{\n            color: $color-Secondary;\n            text-align: center;\n            font-family: $Roboto;\n            font-size: 18px;\n            @media (max-width: 720px){\n                font-size: 14px;\n            }\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px; \n            margin: 0;\n            margin-bottom: 30px;\n\n        }\n        .successBtn{\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 320px;\n            background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n            font-weight: 400;\n            margin-top: 50px;\n            padding: 10px;\n            border-radius: 10px;\n            text-align: center;\n            color: $color-White;\n            font-family: $Roboto;\n            font-size: 16px;\n            border:0px solid;\n            position: absolute;\n            bottom: 100px;\n        }\n        .skipBtn{\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 320px;\n            background: -webkit-linear-gradient($color-Gradient-3-1, $color-Gradient-2-2);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n            background-color: #fff;\n            font-weight: 400;\n            margin-top: 20px;\n            padding: 8px 10px 8px 10px;\n            border-radius: 10px;\n            text-align: center;\n            color: $color-White;\n            font-family: $Roboto;\n            font-size: 16px;\n            border:0px solid;\n            position: absolute;\n            bottom: 40px;\n        }\n}","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
